import "./tableOfContents.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";

const TableofContent = (props) => {
    const { tableContent } = props
 
  return (
    <div className="table-of-contents">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header/>
      {/* Main Body */}
      <main className="toc-body">
        <p>Contents</p>
        {tableContent.length > 0 && tableContent.map((item, index) => {
          return (
            <div className="toc-main" key={index}>
              <div className="toc-entry">
                <a href={item.href}>
                  <p>{item.title}</p>
                </a>
                <a href={item.href}>
                  <p>{item.pageNo}</p>
                </a>
              </div>
            </div>
          );
        })}
      </main>
      {/* Footer */}
      <Footer pageNo={ `2 /${tableContent[tableContent.length - 1].pageNo}`}/>
    </div>
  );
};

export default TableofContent;
